// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__2EFlN","select":"styles_select__i6Kjf","items":"styles_items__8HsjF","pages":"styles_pages__+B5GM","rot":"styles_rot__znMFt"};